<script>
    export let current = 0;
    export let total = 0;
    export let label = "";

    $: progress = total > 0 ? (current / total) * 100 : 0;
</script>

<div class="progress-container">
    <div class="progress-bar bg-base-300">
        <div
            class="progress-fill bg-gradient-to-r from-primary to-secondary"
            style="width: {progress}%"
        ></div>
    </div>
    {#if label || (current && total)}
        <p class="progress-text">
            {label || `${current} sur ${total}`}
        </p>
    {/if}
</div>

<style>
    .progress-container {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .progress-bar {
        width: 100%;
        height: 8px;
        border-radius: 4px;
        overflow: hidden;
    }

    .progress-fill {
        height: 100%;
        transition: width 0.3s ease;
    }

    .progress-text {
        text-align: center;
        font-size: 0.9rem;
        margin: 0;
    }
</style>
